























































































































































































































































































































































































































































































































































































import { Pagination } from '@/common';
import FullCalendar, { CalendarOptions } from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import {
  ClearOutQueryParamMapper,
  getStatusColor,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';
import BaseComponent from '@/core/base.component';
import {
  ConsultResponseV3CreateDto,
  ConsultResponseV3Dto,
  ConsultResponseV3ListDto,
  ConsultMonthlyRequestDto,
  ProductConsultStatusUpdateDto,
  MeetingListDto,
  ConsultBetweenDatesRequestDto,
} from '@/dto';
import { PickcookCodeManagementDto } from '@/services/init/dto';
import {
  PaginationCount,
  CONST_PAGINATION_COUNT,
  RESERVATION_DELETE_REASON,
  CONST_RESERVATION_DELETE_REASON,
  BRAND_CONSULT,
  FNB_OWNER,
  CONST_FNB_OWNER,
} from '@/services/shared';
import { Component, Ref, Watch } from 'vue-property-decorator';
import CommonCodeService from '@/services/pickcook/common-code.service';
import ConsultResponseV3Service from '@/services/pickcook/consult-response-v3.service';
import axios from 'axios';
import toast from '../../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'ConsultResponseV3List',
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
})
export default class ConsultResponseV3List extends BaseComponent {
  private consultResponseV3List: ConsultResponseV3Dto[] = [];
  private consultResponseV3BetweenDates: ConsultResponseV3Dto[] = [];
  private consultResponseV3SearchDto = new ConsultResponseV3ListDto();
  private consultResponseV3CreateDto = new ConsultResponseV3CreateDto();
  private pagination = new Pagination();
  private consultResponseTotalCount = null;
  private newLimit = null;
  private paginationCount: PaginationCount[] = [...CONST_PAGINATION_COUNT];
  private searchPramsDto: any = {};
  private dataLoading = false;
  private fnbOwnerStatus: PickcookCodeManagementDto[] = [];
  private consultStatus: PickcookCodeManagementDto[] = [];
  private codeManagementDto = new PickcookCodeManagementDto();
  private paginationCode = new Pagination();

  private reservationDeleteReasons: RESERVATION_DELETE_REASON[] = [
    ...CONST_RESERVATION_DELETE_REASON,
  ];

  private selectedProductConsultNos: number[] = [];
  private consultStatusUpdateDto = new ProductConsultStatusUpdateDto();
  private newDate = new Date();
  private monthlyMeetings = new MeetingListDto();
  private consultBetweenDatesRequestDto = new ConsultBetweenDatesRequestDto();
  private isShowCalendar = false;
  private calendarApi = null;
  private calendarOptions: CalendarOptions = {
    plugins: [interactionPlugin, dayGridPlugin],
    headerToolbar: {
      left: 'prev,next',
      center: 'title',
      right: 'today',
    },
    buttonText: {
      today: '오늘',
      day: '일',
      week: '주',
      month: '월',
    },
    // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
    // editable: true,
    height: 750,
    selectable: true,
    showNonCurrentDates: false,
    initialView: 'dayGridMonth',
    locale: 'ko',
    slotMinTime: '10:00:00',
    slotMaxTime: '19:00:00',
    slotDuration: '01:00:00',

    eventClick: this.pushToDetailPage,
    datesSet: this.onDatesSet,
    select: this.onSelect,
  };
  // excel options
  private fields = {
    ID: 'id',
    이름: 'name',
    // 나이: 'ageGroupCodeStatus.displayName',
    연락처: 'phone',
    // 미팅예약날짜: 'reservation.reservationDate',
    // 미팅예약시간: 'reservation.reservationTime',
    // 미팅취소사유: 'reservation.deleteReason',
    // 취소기타사유: 'reservation.deleteReasonEtc',
    미팅날짜: 'meetingDate',
    담당자: 'admin.name',
    신청상태: 'consultCodeStatus.comment',
    신청일: 'created',
  };
  private json_meta = [
    [
      {
        key: 'charset',
        value: 'utf-8',
      },
    ],
  ];

  private correctedEndDate: string = null;
  private BRAND_CONSULT = BRAND_CONSULT;

  get newConsultCount() {
    return this.consultResponseV3BetweenDates.filter(
      e => e.consultStatus == BRAND_CONSULT.NEW_CONSULT,
    ).length;
  }
  get callLaterCount() {
    return this.consultResponseV3BetweenDates.filter(
      e => e.consultStatus == BRAND_CONSULT.CONSULT_CALL_LATER,
    ).length;
  }

  get cannotContactCount() {
    return this.consultResponseV3BetweenDates.filter(
      e => e.consultStatus == BRAND_CONSULT.CONSULT_CANNOT_CONTACT,
    ).length;
  }
  get consultCompleteCount() {
    return this.consultResponseV3BetweenDates.filter(
      e => e.consultStatus == BRAND_CONSULT.CONSULT_COMPLETE,
    ).length;
  }
  get consultDropCount() {
    return this.consultResponseV3BetweenDates.filter(
      e => e.consultStatus == BRAND_CONSULT.CONSULT_DROPPED,
    ).length;
  }
  get willMeetCount() {
    return this.consultResponseV3BetweenDates.filter(
      e => e.consultStatus == BRAND_CONSULT.CONSULT_WILL_MEET,
    ).length;
  }
  get meetingCompleteCount() {
    return this.consultResponseV3BetweenDates.filter(
      e => e.consultStatus == BRAND_CONSULT.CONSULT_MEETING_COMPLETE,
    ).length;
  }
  get noShowCount() {
    return this.consultResponseV3BetweenDates.filter(
      e => e.consultStatus == BRAND_CONSULT.CONSULT_MEETING_NO_SHOW,
    ).length;
  }
  get meetingSecondCount() {
    return this.consultResponseV3BetweenDates.filter(
      e => e.consultStatus == BRAND_CONSULT.CONSULT_MEETING_SECOND,
    ).length;
  }
  get contractInProgCount() {
    return this.consultResponseV3BetweenDates.filter(
      e => e.consultStatus == BRAND_CONSULT.CONSULT_CONTRACT_IN_PROG,
    ).length;
  }
  get consultContractedCount() {
    return this.consultResponseV3BetweenDates.filter(
      e => e.consultStatus == BRAND_CONSULT.CONSULT_CONTRACTED,
    ).length;
  }

  // get status color
  getStatusColor(status: BRAND_CONSULT) {
    return getStatusColor(status);
  }

  getMeetings(date) {
    ConsultResponseV3Service.getMeetingsMonthly(date);
  }

  // get common codes
  getCommonCodes() {
    this.codeManagementDto.category = 'FNB_OWNER';
    CommonCodeService.findAll(
      this.codeManagementDto,
      this.paginationCode,
    ).subscribe(res => {
      this.fnbOwnerStatus = res.data.items;
    });

    this.codeManagementDto.category = 'BRAND_CONSULT';
    CommonCodeService.findAll(
      this.codeManagementDto,
      this.paginationCode,
    ).subscribe(res => {
      this.consultStatus = res.data.items;
    });
  }

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    this.pagination.limit = this.newLimit;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.consultResponseV3SearchDto, this.pagination);
    }

    ConsultResponseV3Service.findAll(
      this.consultResponseV3SearchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.dataLoading = false;
        this.consultResponseV3List = res.data.items;
        this.consultResponseTotalCount = res.data.totalCount;
      }
    });
  }
  search() {
    this.findAll(true, true);
  }

  paginateSearch() {
    this.findAll(true);
  }
  pushToDetailPage(info) {
    const id = info.event._def.title.split('_')[0];
    this.$router.push(`/pickcook/consult-response-v3/${id}`);
  }
  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.consultResponseV3SearchDto = new ConsultResponseV3ListDto();
      this.findAll();
    }
  }

  createProforma() {
    axios.get('https://api.ipify.org?format=json').then(res => {
      this.consultResponseV3CreateDto.ipAddress = res.data.ip;
    });
  }

  createConsult() {
    ConsultResponseV3Service.create(this.consultResponseV3CreateDto).subscribe(
      res => {
        if (res) {
          toast.success('추가완료');
          this.clearOut();
        }
      },
    );
  }

  onDatesSet(date) {
    //처음 렌더될때, 캘린더 뷰가 변할때마다 해당년도와 달로 meeting 리스트를 가져와서 뿌림
    const consultMonthlyRequestDto = new ConsultMonthlyRequestDto();
    const year = date.start.getFullYear();
    const month = date.start.getMonth() + 1;
    consultMonthlyRequestDto.year = year;
    consultMonthlyRequestDto.month = month;
    ConsultResponseV3Service.getMeetingsMonthly(
      consultMonthlyRequestDto,
    ).subscribe(res => {
      this.calendarApi = (this.$refs['fullCalendar'] as any).getApi();
      if (res) {
        this.monthlyMeetings = res.data;
        this.calendarApi.getEvents().forEach(e => {
          e.remove();
        });
        res.data.forEach(e => {
          this.calendarApi.addEvent(e);
        });
      }
    });
  }

  onSelect(selectInfo) {
    this.consultBetweenDatesRequestDto.startDate = selectInfo.startStr;
    this.consultBetweenDatesRequestDto.endDate = selectInfo.endStr;
    const end = selectInfo.end;
    this.correctedEndDate = new Date(end - 100).toISOString().slice(0, 10);

    ConsultResponseV3Service.getConsultsBetween(
      this.consultBetweenDatesRequestDto,
    ).subscribe(res => {
      if (res) {
        this.consultResponseV3BetweenDates = res.data;
      }
    });
  }

  created() {
    this.newLimit = PaginationCount.TWENTY;
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.consultResponseV3SearchDto = query;
      this.pagination.page = +query.page;
      this.newLimit = +query.limit;
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getCommonCodes();
  }
}
